import { Box, TextField, InputAdornment } from "@mui/material";
import styles from "../../styles/pages/mymessagePurchasedRequest.module.scss";
import React, { useEffect } from "react";
import { Button } from "@imarabinda/antd";
import assest from "../../json/assest";
import { useForm, Controller } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const validationSchema = Yup.object().shape({
  vsid: Yup.number()
    .typeError("VSID must be a number")
    .required("VSID is required")
    .positive("VSID must be a positive number"),
});

const PurchasedBox = ({ purchased, updateVsid, video }) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    updateVsid(data?.vsid);
  };

  useEffect(() => {
    setValue("vsid", video?.vsid ? `#${video.vsid}` : "");
  }, [video]);

  return (
    <Box className={styles.purchasedBox}>
      <Box className={styles.purchasedBoxHead}>
        <p>purchased?</p>
        {purchased === 0 ? (
          <Button className={styles.pendingButton}>Pending</Button>
        ) : purchased === 1 ? (
          <Button>Yes</Button>
        ) : (
          <Button className={styles.noButton}>No</Button>
        )}
      </Box>
      {purchased === 1 ? (
        <Box className={styles.vsidBox}>
          <p>VSID:</p>
          <Controller
            name="vsid"
            control={control}
            // defaultValue={vsidValue}
            render={({ field }) => (
              <>
                <Box className={styles.purchasedVisdBoxWrapper}>
                  <Box className={styles.purchasedVisdBox}>
                    <input {...field} type="text" />
                    <Button onClick={handleSubmit(onSubmit)}>
                      <img src={assest.vsidcopyIcon} width={10} height={10} alt="" />
                    </Button>
                  </Box>
                  {errors.vsid && <p className={styles.purchasedVisdError}>{errors.vsid.message}</p>}
                </Box>
              </>
            )}
          />

        </Box>
      ) : (
        ""
      )}
    </Box>
  );
};

export default PurchasedBox;
